export const getFullName = (firstName?: string, lastName?: string) =>
  firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || '';
